import React, { Fragment } from 'react';
import T from 'prop-types';
import { chunk } from 'lodash-es';

import AppIcon from '../../../../components/AppIcon';
import SimpleDropdown from '../../../../components/Dropdowns/SimpleDropdown';

const CompanySelection = ({ onChange, selected, options, popularCompanies = [] }) => (
  <Fragment>
    <div className="companies-dropdown">
      <SimpleDropdown
        selected={selected}
        options={options}
        variant="light"
        portal={false}
        position="initial"
        menuGap={0}
        menuWidth={340}
        onChange={onChange}
      />
    </div>
    {popularCompanies.length > 0 && (
      <div className="popular-companies-selection">
        <h4 className="popular-companies-title">Popular companies:</h4>
        <div className="popular-companies-container">
          {chunk(popularCompanies, 5).map((companies, i) => (
            <div key={i} className="popular-companies">
              {companies.map((company) => (
                <div
                  key={company.ticker}
                  className="popular-company"
                  onClick={() => onChange(company.ticker)}
                >
                  <div className="popular-company-app-img">
                    {company.icon_url ? (
                      <AppIcon
                        size={34}
                        url={company.icon_url}
                        url2x={company.icon_url_2x}
                        store="unified"
                        withBorder
                      />
                    ) : (
                      <div className="popular-company-placeholder">
                        <div className="popular-company-icon" />
                      </div>
                    )}
                  </div>
                  <span className="popular-company-name text-truncate">{company.company_name}</span>
                  <span className="hicon-angle-right-alt" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    )}
  </Fragment>
);

CompanySelection.propTypes = {
  onChange: T.func.isRequired,
  options: T.array.isRequired,
  popularCompanies: T.array,
  selected: T.string,
};

export default CompanySelection;
